export class DataHelper {
  /**
   * Vérifie si une valeur est `null` ou `undefined`
   * @param {T} value
   * @returns {boolean}
   */
  static isNullish(value: any | null | undefined): boolean {
    return [null, undefined].includes(value);
  }
}
